
<div class="checkout-quantity-button-container" fxLayout ="row" fxLayoutAlign="center center">
    <img (click)="onSubstractQuantity($event)" src="assets/image/icon/minus-qty-icon.png" alt="">
    <span class="quantity">{{selectedQuantity}}</span>
    <img (click)="onAddQuantity($event)" src="assets/image/icon/add-qty-icon.png" alt="">
</div>
  